import { useSelector } from 'react-redux';
import { SystemSliceState } from 'redux/slice/system.slice';
import { RootState } from 'redux/store';

export const useAuthInfo = (): SystemSliceState => {
  const sys = useSelector((state: RootState) => state.system);
  return sys;
};
